import axios from 'axios';

export default {
    get(context, courseId, raw, termId, termType, week) {
        var options = {
            url: window.apiUrl + '/course?course=' + courseId + '&raw=' + raw + '&termId=' + termId + '&termType=' + termType +'&week=' + week,
            params: {
                 // cache: 'course'
            },
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    getAll() {
        var options = {
            url: window.apiUrl + '/courses',
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    getInstructorCourses(context, limitTerms) {
        let url = window.apiUrl + '/instructor-courses';
        if (limitTerms) {
            url += '?limit_terms=true'
        }
        var options = {
            url: url,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },

    getMine(context) {
        var options = {
            url: window.apiUrl + '/my-courses',
            method: 'GET',
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },
    addDescription(context, description) {
        var options = {
            url: window.apiUrl + '/course-description',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            method: 'POST',
            data: description
        };
        return axios.request(options).then(function(response) {
            return response;        
        });  
    },
    getPaths(context) {
        var options = {
            url: window.apiUrl + '/paths',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            method: 'GET'            
        };
        return axios.request(options).then(function(response) {
            return response;        
        });  
    },
    updateInstance(data) {       
        var options = {
            url: window.apiUrl + '/instance',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            method: 'PATCH',
            data: data
        }        

        return axios.request(options).then(function(response) {
             return response;
        }).catch(function(error) {
            console.log('ERROR');
            console.log(error)
            return(error);

        });
    },
    update(data) {       
        var options = {
            url: window.apiUrl + '/course',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            method: 'PATCH',
            data: data
        }        

        return axios.request(options).then(function(response) {
             return response;
        }).catch(function(error) {
            console.log('ERROR');
            console.log(error)
            return(error);

        });
    },
    setImage(context, id, url) {
        var data = {
            id: id,
            url: url
        }
        var options = {
            url: window.apiUrl + '/course-image',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            method: 'POST',
            data: data
        };
        return axios.request(options).then(function(response) {
            return response;        
        });  
    },
    getPrograms() {
        var options = {
            url: window.apiUrl + '/programs',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            method: 'GET'            
        };
        return axios.request(options).then(function(response) {
            return response;        
        });  
    },
};



// WEBPACK FOOTER //
// ./src/services/courses/index.js